module.exports = __webpack_public_path__ + "img/pg3-article3-bg.72ce40db.png";